import React, { FC } from "react"
import { PopUp } from "../PopUp/PopUp"
import { POP_UP } from "../DropdownMenu/DropdownMenu.presets"
import ClickableBackground from "../ClickableBackground"
import Picker from "emoji-picker-react"

interface Props {
  children?: ({ show }: { show: () => void }) => React.ReactNode
  onChange(value: string): void
}

const EmojiField: FC<Props> = (props) => {
  const { onChange, children } = props

  const onEmojiClick = (event: any, emojiObject: any) => {
    onChange(emojiObject.emoji)
    hidePopUp()
  }

  let popUp: PopUp | null = null

  const setPopUpRef = (ref: PopUp) => {
    popUp = ref
  }
  const hidePopUp = () => {
    popUp?.hide()
  }

  const showPopup = () => {
    popUp?.show()
  }

  return (
    <PopUp
      style={POP_UP}
      animationType="fade"
      transparent={true}
      ref={setPopUpRef}
      anchor={children?.({ show: showPopup })}
    >
      <ClickableBackground onPress={hidePopUp} />
      <Picker onEmojiClick={onEmojiClick} disableAutoFocus={true} native />
    </PopUp>
  )
}

export default EmojiField
